import React, { useEffect } from "react";
import StudentOrdersListing from "./StudentOrdersListing";
import { columnTypes } from "src/components/UI/atoms/ATMTable/ATMTable";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import {
  setPage,
  setRowsPerPage,
  setSearchValue,
  setIsTableLoading,
  setItems,
  setTotalItems,
} from "src/redux/slices/StudentOrderSlice";
import { useGetAllOfflineOrderDataQuery } from "src/services/OfflineOrderService";
import ListDateTime from "src/components/UI/atoms/ListDateTime/ListDateTime";
import { Tooltip } from "@mui/material";
import { useParams } from "react-router-dom";

type Props = {};

const StudentOrdersListingWrapper = (props: Props) => {
  const dispatch = useDispatch();
  const { items, totalItems, page, rowsPerPage, searchValue, isTableLoading } =
    useSelector((state: RootState) => state.studentOrder);

  const { studentId } = useParams()
  const { data, isLoading, isFetching } = useGetAllOfflineOrderDataQuery({
    limit: rowsPerPage,
    searchValue: searchValue,
    params: ["name", "mobile"],
    page: page,
    filterBy: [
      {
        fieldName: "userId",
        value: studentId 

      }
    ],
    dateFilter: {},
    orderBy: "createdAt",
    orderByValue: -1,
    isPaginationRequired: true,
  });

  // Setting Module Data
  useEffect(() => {
    if (isLoading || isFetching) {
      dispatch(setIsTableLoading(true));
    } else {
      dispatch(setItems(data?.data || []));
      dispatch(setIsTableLoading(false));
      dispatch(setTotalItems(data?.totalItem || 0));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isLoading, isFetching]);


  const columns: columnTypes[] = [
    {
      field: "createdAt",
      headerName: "Date - Time",

      extraClasses: "min-w-[150px] py-1 min-w-[150px]",
      flex: "flex-[1_1_0%]",
      renderCell: (row: any) => <ListDateTime value={row.createdAt} />,
    },
    {
      field: "orderNumber",
      headerName: "Order Number",
      extraClasses: "justify-center",
      flex: "flex-[1.5_1_0%]",
    },
    {
      field: "name",
      headerName: "Name",
      flex: "flex-[1_1_0%]",
      renderCell: (row: any) =>
        <Tooltip title={row?.name}>
          <div className="capitalize text-md"> {row?.name} </div>
        </Tooltip>
    },
    {
      field: "email",
      headerName: "Email",
      flex: "flex-[1.5_1_0%]",
      renderCell: (row: any) => (
        <Tooltip title={row?.email}>
          <div className="capitalize text-md"> {row?.email} </div>
        </Tooltip>
      ),
    },
    {
      field: "mobile",
      headerName: "Mobile",
      flex: "flex-[1_1.5_0%]",
      renderCell: (row: any) => (
        <div className="capitalize text-md"> {row?.mobile} </div>
      ),
    },
    {
      field: "orderTotal",
      headerName: "Amount",
      flex: "flex-[1.5_1.5_0%]",
      renderCell: (row: any) => <div>&#8377; {row?.orderTotal}</div>,
    },
    {
      field: "dueAmt",
      headerName: "Remaining Fees",
      flex: "flex-[1.5_1.5_0%]",
      renderCell: (row: any) => <div>&#8377; {row?.dueAmt}</div>,
    },
    // { field: "courseName", headerName: "Course", flex: "flex-[1.5_1.5_0%]" },
  ];

  return (
    <div>
      <StudentOrdersListing
        columns={columns}
        rows={items}
        paginationProps={{
          isTableLoading,
          totalItems,
          page,
          rowsPerPage,
          searchValue,
          setPage: (newPage) => dispatch(setPage(newPage)),
          setRowsPerPage: (newRowsPerPage) =>
            dispatch(setRowsPerPage(newRowsPerPage)),
          setSearchValue: (newValue) => dispatch(setSearchValue(newValue)),
        }}
      />
    </div>
  );
};

export default StudentOrdersListingWrapper;
